import { useContext, useState } from 'react';
import { OrderContext } from '../context/OrderContext';

const useCompleteClaimInvoice = () => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const {apiClient, uuid, claimId} = useContext(OrderContext);


  const completeClaim = async (note) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.post(`api/v1/refund/${uuid}/complete_claim/`, {
        claim_id : claimId,
        note : note
      });
      const data = response.data;
     

    } catch (error) {
      const msg = error.response?.data?.error || error.message || 'API error';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return {completeClaim};
};

export default useCompleteClaimInvoice;
